import { FunctionComponent, useEffect } from "react";
import useNav from "../../../../hooks/useNav";
import { useForm } from "react-hook-form";
import { Button, FormControl, FormLabel, Modal, TextareaAutosize, TextField } from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { SelectSede } from "../../../../components/selects/sede";
import { SelectMinisterioGrupo } from "../../../../components/selects/ministerioGrupo";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";


export const GrupoCelulaEdit: FunctionComponent = () => {


  const {
    goBack,
  } = useNav();

  const {
    id
  } = useParams();

  const { startLoading, stopLoading, isLoading } = useLoading();
  const { setMensagemSuccess, setMensagemError } = useErrorSuccess();

  const getGrupoCelula = async () => {
    let req = await api.get('ministerio/geral/v2/buscar/' + id);
    setValue('descricao', req.data.descricao);
    setValue('grupo', req.data.grupo);
    setValue('sede', req.data.sede);
    setValue('observacao', req.data.observacao);
  }

  const {
    register,
    watch,
    setValue,
    handleSubmit
  } = useForm<{ sede: number, descricao: string, observacao: string, grupo: number }>({
    defaultValues: {
      sede: null,
      descricao: null,
      observacao: null,
      grupo: null
    }
  });

  useEffect(() => {
    getGrupoCelula()
  }, [])

  const put = handleSubmit(async (values) => {
    startLoading()
    try {
       await api.put('ministerio/geral/'+id, values);
       setMensagemSuccess('Alteração com Sucesso!');
       goBack();
    } catch (error) {
      setMensagemError(JSON.stringify(error?.error?.mensagem, null, 2)|| 'Erro ao tentar alterar');
    } finally {
      stopLoading()
    }
  })


  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal>
          <SelectSede action={(action) => setValue('sede', action)} value={watch('sede')} />
          <SelectMinisterioGrupo action={(action) => setValue('grupo', action?.target?.value)} valor={watch('grupo')} />

          <FormControl sx={{ mt: 1 }} fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <FormControl sx={{ mt: 1 }} fullWidth>
            <FormLabel>Observação</FormLabel>
            <TextareaAutosize
              style={{
                minHeight: 60,
                borderColor: '#ccc',
                borderRadius: 4,
                resize: 'none',
                padding: '4px 8px'
              }}
              maxRows={8}
              cols={60}
              {...register('observacao')}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained" onClick={put} disabled={isLoading}>Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}

